import { useEffect, useMemo, useRef, useState } from "react";
import "./searchstyle.scss";
import { getValue, setValue } from "@utils/lodash";
import { sanitizeInput } from "@_common/dompurify";
import { debounceSearch } from "@_common/common-helper";
const SearchableDropdownSelect = (props) => {
  const {
    options,
    label,
    id,
    handleChange,
    handleClick,
    value,
    placeholder,
    searchLoading,
    removeClose,
    disabled,
  } = props;

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [inputChange, setInputChange] = useState(false);
  const inputRef = useRef(null);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    document.addEventListener("click", toggle);
    document.addEventListener("mouseup", toggle);
    return () => {
      document.removeEventListener("click", toggle);
      document.addEventListener("mouseup", toggle);
    };
  }, []);

  useEffect(() => {
    setQuery("");
  }, [props.resetInput]);
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const filter = (options) => {
    return getValue(options, `length`, 0) > 0
      ? options.filter(
          (option) =>
            getValue(option, `[${label}]`, "") &&
            option[label].toLowerCase().indexOf(query.toLowerCase()) > -1
        )
      : [];
  };
  useEffect(() => {
    if (query) {
      setInputChange(true);
    }
  }, [query]);

  const debouncedSearch = useMemo(
    () =>
      debounceSearch((e) => handleChange(sanitizeInput(e.target.value)), 500),
    []
  );

  const handleChangeSearch = (e) => {
    setQuery(sanitizeInput(e.target.value));
    debouncedSearch(e);
  };

  return (
    <div
      className={"dropdownselect"}
      style={getValue(props, `className`, "") ? { width: "720px" } : {}}
    >
      <div className="control">
        <div className="selected-value">
          <input
            ref={inputRef}
            type="text"
            value={
              inputChange
                ? query
                  ? query
                  : getValue(value, `label`, "")
                : getValue(value, `label`, "")
                ? getValue(value, `label`, "")
                : query
            }
            title={
              inputChange
                ? query
                  ? query
                  : getValue(value, `label`, "")
                : getValue(value, `label`, "")
                ? getValue(value, `label`, "")
                : query
            }
            name="searchTerm"
            id="search-text"
            // autoComplete="off"
            autoComplete="off"
            onChange={(e) => handleChangeSearch(e)}
            onClick={toggle}
            placeholder={placeholder}
            style={
              getValue(props, `className`, "")
                ? {
                    width: "740px",
                    backgroundColor: disabled ? "#F0F3F4" : "transparent",
                  }
                : { backgroundColor: disabled ? "#F0F3F4" : "transparent" }
            }
            disabled={props.disabled}
          />
        </div>
        <div className="line"></div>
        {searchLoading ? (
          <div className="arrowtext">...</div>
        ) : (
          <div className={`arrow ${isOpen ? "open" : ""}`}></div>
        )}
        {/* <div className="line" onClick={handleTriggerAPI}>&#128269;</div>&#10006; */}
        {(query || getValue(value, `label`, "")) &&
          !removeClose &&
          !disabled && (
            <div
              className="header-close-btn close"
              onClick={(e) => {
                setQuery("");
                handleChange(null);
              }}
            >
              &#x2715;
            </div>
          )}
      </div>

      <div
        className={`options ${isOpen && !disabled ? "open" : ""}`}
        style={getValue(props, `className`, "") ? { width: "740px" } : {}}
      >
        {getValue(options, `length`, 0) > 0 &&
        getValue(filter(options), `length`, 0) > 0 ? (
          filter(options).map((option, index) => {
            return (
              <div
                onClick={() => {
                  handleClick(option);
                  setInputChange(false);
                }}
                className={`option ${
                  option[id] === getValue(value, `id`, "") ? "selected" : ""
                }`}
                key={`${id}-${index}`}
              >
                {option[label]}
              </div>
            );
          })
        ) : (
          <div className={`option `} style={{ textAlign: "center" }}>
            No Data Found
          </div>
        )}
      </div>
      {props.validator && (
        <span className="form-error">
          {props.validator.current.message(props.name, props.value, "required")}
        </span>
      )}
    </div>
  );
};

export default SearchableDropdownSelect;
